import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { czechLocale } from '@o2/ui/DatePicker';
import O2AppUI from '@o2/ui/O2AppUI';
import { RouteRender } from './helpers/routes/routeRender';
import routes, { getCurrentRoute } from './helpers/routes/routes';
import { AppState } from './helpers/store/models/AppState';
import { isProdEnvironment } from './saga/appHandlers/ducks';
import { selectIsUserInternal } from './saga/auth/ducks';
import KahlMessage from './views/components/KahlMessage/KahlMessage';
import { NewAppLayout } from './views/layout/NewLayout/NewAppLayout';
import Loading from '@o2/common-business/Loading';

const AppContentComponent = ({ isInternal, simplePage }: StateToProps) => {
  const { i18n } = useTranslation();

  const config = {
    dateLocale: 'cs',
  };

  return (
    <O2AppUI config={{ dateLocale: i18n.language }}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={config.dateLocale} localeText={czechLocale}>
        {/*TODO: temporary solution APF-3093*/}
        {simplePage ? (
          <React.Suspense fallback={<Loading />}>
            <RouteRender routes={routes} />
          </React.Suspense>
        ) : (
          <NewAppLayout isInternal={isInternal} />
        )}
        <KahlMessage />
      </LocalizationProvider>
    </O2AppUI>
  );
};

interface StateToProps {
  isInternal?: boolean;
  simplePage?: boolean | undefined;
  isProd?: boolean;
}

const mapStateToProps = (state: AppState): StateToProps => ({
  isInternal: selectIsUserInternal(state),
  simplePage: !!getCurrentRoute()?.commonPageData?.simplePage,
  isProd: isProdEnvironment(),
});

export const AppContent = connect(mapStateToProps, null)(AppContentComponent);
